export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-5" style={{ fontFamily: 'var(--font-heading)' }}>
              关于漫蛙
            </h2>
            <div className="space-y-4 text-base text-foreground-700 leading-relaxed">
              <p>
                漫蛙漫画网是一个专注于<strong>漫画追更</strong>与<strong>漫画最新更新</strong>追踪的专业平台。我们深知每一位漫友对连载漫画的热爱与期待，因此致力于打造最快、最全、最贴心的追更体验。
              </p>
              <p>
                从热血战斗到悬疑推理，从国漫精品到日漫经典，漫蛙汇聚了海量<strong>连载漫画追更</strong>资源，覆盖全题材、全平台。无论是周刊连载、双周更新还是月刊发布，你都能在这里第一时间获取<strong>漫画更新提醒</strong>。
              </p>
              <p>
                我们的追更引擎实时同步全网漫画更新动态，确保<strong>追漫画更新</strong>的速度始终领先。配合个性化追更列表与智能推荐系统，让每一位漫友都能轻松管理自己的追更计划，不错过任何一话精彩内容。
              </p>
              <p>
                漫蛙漫画网的使命是成为中文互联网最好的<strong>漫画追更网站</strong>，让<strong>免费漫画追更</strong>变得更加简单、高效和愉快。追更路上，漫蛙与你同行。
              </p>
            </div>
          </div>
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20corner%20with%20colorful%20manga%20books%20stacked%20on%20a%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20warm%20coral%20and%20amber%20accents%2C%20comfortable%20atmosphere%2C%20artistic%20flat%20lay%20photography%20style%2C%20clean%20background&width=800&height=600&seq=manwa-about-img&orientation=landscape"
                alt="漫蛙漫画网 - 关于我们"
                className="w-full h-auto object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}